import * as React from 'react'

function SvgSn(props) {
	return (
		<svg viewBox="0 0 900 600" width="1em" height="1em" {...props}>
			<path fill="#00853f" d="M0 0h300v600H0z" />
			<path fill="#fdef42" d="M300 0h300v600H300z" />
			<path fill="#e31b23" d="M600 0h300v600H600z" />
			<g transform="translate(450 300)" fill="#00853f">
				<g id="sn_svg__b">
					<path id="sn_svg__a" d="M0-100V0h50z" transform="rotate(18 0 -100)" />
					<use xlinkHref="#sn_svg__a" transform="scale(-1 1)" />
				</g>
				<use xlinkHref="#sn_svg__b" transform="rotate(72)" />
				<use xlinkHref="#sn_svg__b" transform="rotate(144)" />
				<use xlinkHref="#sn_svg__b" transform="rotate(216)" />
				<use xlinkHref="#sn_svg__b" transform="rotate(288)" />
			</g>
		</svg>
	)
}

export default SvgSn
